<template>
    <div class="hotdata">
        <div class="hotitem" @click="statistics('vent')">
            <div class="icon">
                <img class="icon-top" src="../../../assets/newscreen/icon_paifang.png" alt="">
                <img class="light" src="../../../assets/newscreen/bg_redian_2.png" alt="">
            </div>

            <div class="icon-text">
                <div class="text">站点总数</div>
                <div class="number HF-Duguts">{{ countObj.ventCount }}</div>
            </div>
        </div>
        <div class="hotitem" @click="statistics('warn')">
            <div class="icon">
                <img class="icon-top" src="../../../assets/newscreen/icon_yujing.png" alt="">
                <img class="light" src="../../../assets/newscreen/bg_redian_2.png" alt="">
            </div>
            <div class="icon-text">
                <div class="text">预告警数</div>
                <div class="number HF-Duguts">{{ countObj.warnCount }}</div>
            </div>
        </div>
        <div class="hotitem" @click="statistics('shut')">
            <div class="icon">
                <img class="icon-top" src="../../../assets/newscreen/icon_tingyun.png" alt="">
                <img class="light" src="../../../assets/newscreen/bg_redian_2.png" alt="">
            </div>
            <div class="icon-text">
                <div class="text">生产停运数</div>
                <div class="number HF-Duguts">{{ countObj.shutDownCount }}</div>
            </div>
        </div>
        <countdialog ref="countdialogRef"></countdialog>
    </div>
</template>

<script>
import countdialog from '../dialog/countdialog.vue';

export default {
    components: {
        countdialog
    },
    props: {
        siteList: {
            type: Array,
            default: () => []
        },
        countObj: {
            type: Object,
            default: () => {
                return {
                    warnCount: 0,
                    shutDownCount: 0,
                    ventCount: 0
                }
            }
        }
    },
    computed: {
        siteTotal() {
            if (this.siteList && this.siteList.length) {
                return this.siteList.length;
            } else {
                return 0;
            }
        },
        warnTotal() {
            if (this.siteList && this.siteList.length) {
                return this.siteList.filter(item => {
                    return item.status == 2 || item.status == 8 || item.status == 16 || item.status == 64 || item.status == 256
                }).length;
            } else {
                return 0;
            }
        },
        stopTotal() {
            if (this.siteList && this.siteList.length) {
                return this.siteList.filter(item => {
                    return item.status == 4 || item.status == 256 || item.status == 128
                }).length;
            } else {
                return 0;
            }
        }
    },
    methods: {
        statistics(msg) {
            this.$refs.countdialogRef.statistics(msg)
        }
    },
}
</script>

<style lang="scss" scoped>
.hotdata {
    width: 100%;
    height: 100%;
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    font-size: 1rem;

    .hotitem {
        // background: url(../../../assets/newscreen/bg_redian_1.png) no-repeat;
        // background-size: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;


        .icon {
            position: relative;
            margin-top: 1rem;

            .icon-top {
                display: block;
                position: absolute;
                left: 0;
                right: 0;
                top: -1rem;
                margin: auto;
                max-width: 2.86rem;
                max-height: 2.86rem;
                animation: rotate-3d 5s infinite ease-in-out;
                transform-style: preserve-3d;
            }

            .light {
                display: block;
                width: 5rem;
                height: 5rem;
                // animation: hahah 2s linear infinite alternate;
                // bottom: -1.25rem;
                // left: 50%;
                // transform: translateX(-50%);
            }
        }

        .icon-text {
            text-align: center;
            // position: absolute;
            // top: 1.5rem;
            // left: 50%;

            // transform: translateX(-50%);

            .text {
                font-size: 1rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #fff;
            }

            .number {
                font-size: 2rem;
                color: #FFFFFF;
                letter-spacing: 0;
                text-shadow: 0 0 20px rgba(10, 146, 255, 0.45);
                font-weight: 900;
            }
        }
    }
}

@keyframes rotate-3d {
    0% {
        transform: rotateY(0deg) rotateX(20deg);
    }

    100% {
        transform: rotateY(360deg) rotateX(20deg);
    }
}

@keyframes hahah {
    from {
        width: 80%;
    }

    to {
        width: 90%;
    }
}
</style>